var exports = {
  "r": "CardBaseWithSash__IOrIYz",
};

module.exports = exports;
